export enum CalculationRequestTypeEnum {
  OfficerManual='OfficerManual',
  DapFirst='DapFirst',
  DapRecalculate='DapRecalculate',
  OperationCost='OperationCost',
  RecalculateWithOperationCost='RecalculateWithOperationCost',
  RecalculateSpread='RecalculateSpread',
  OfficerRecalculate='OfficerRecalculate',
  OfficerDapFirst='OfficerDapFirst'
}



// WEBPACK FOOTER //
// ./src/services/interfaces/calculator/CalculationRequestTypeEnum.ts